import { render, staticRenderFns } from "./PosLoginView.vue?vue&type=template&id=dd9c0bd2&scoped=true"
import script from "./PosLoginView.vue?vue&type=script&lang=js"
export * from "./PosLoginView.vue?vue&type=script&lang=js"
import style0 from "./PosLoginView.vue?vue&type=style&index=0&id=dd9c0bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9c0bd2",
  null
  
)

export default component.exports